import React, { useState, useContext } from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';
import {
  LicensesContext,
  actionTypes,
} from '../../../containers/pages/BillingLicenses/licensesContext/index';

const StyledDialogText = styled(Typography)`
  width: 347px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

export const OpenQuoteModal = () => {
  const [modalOpen, setModalOpen] = useState(true);

  const { dispatch } = useContext(LicensesContext);

  const onOkButtonClick = (): void => {
    setModalOpen(false);
    dispatch({
      type: actionTypes.TOGGLE_PURCHASE_LICENSE_MODAL,
    });
  };

  return (
    <SimpleDialog
      data-testid="PlatformAdminUI-PurchaseLicenseModal-OpenQuoteModal"
      confirmButtonProps={{
        color: 'primary',
        onClick: onOkButtonClick,
        'data-testid':
          'PlatformAdminUI-PurchaseLicenseModal-OpenQuoteModalOkButton',
      }}
      confirmText="OK"
      title="Account has an open quote"
      open={modalOpen}
    >
      <StyledDialogText variant="body2">
        Once this quote is closed you can retry to purchase this license.
      </StyledDialogText>
    </SimpleDialog>
  );
};
